import { Module } from "vuex";

const Formatter: Module<any, any> = {
    state: {
        formatData: ''
    },
    mutations: {
        setFormatData(state: any, value: string) {
            state.formatData = value;
        },
    },
    actions: {
        setFormatData (newValue) {
            this.state.formatData = newValue
        },
        clearFormatData () {
            this.state.formatData = ''
        }
    },
    getters: {
        formatData: state => state.formatData,
    },
};

export default Formatter;
